export type BillingApprovalLevel = {
    candidateIds: string[];
    approverId?: string;
    approverDecision?: string;
    approverNotes?: string;
    reviewTime?: string;
};

export type Billing = {
    billingNumber: string;
    amount: string;
    fromDate: string;
    toDate: string;
    projectId: string;
    projectName: string;
    notes: string;
    pdfId: string;
    approval: string;
    approverNotes?: string;
    submitterEmail: string;
    submitTime: string;
    updaterEmail: string;
    updateTime: string;
    requestorEmail: string;
    notify: string;
    billed: string;
    billable: string;
    void: string;
    voidReason: string;
    decision?: string;
    submitter?: string;
    updater?: string;
    requestor?: string;
    [key: string]: any;
};

export type BillingUser = {
    email: string;
    userName: string;
    purchases?: string;
    [key: string]: any;
};

export type BillingProject = {
    projectId: string;
    projectName: string;
    [key: string]: any;
};

export type BillingAssignment = {
    labor: string;
    laborName: string;
    startTime: string;
    endTime: string;
    travelStartTime: string;
    workStartTime: string;
    workEndTime: string;
    travelEndTime: string;
    assignmentStatus: string;
    jobTag: string;
    [key: string]: any;
};

export type BillingListLoaderData = {
    weekStart: string;
    weekEnd: string;
    billings: Billing[];
};

export type BillingOutletContext = {
    billings: Billing[];
};

export const defaultBilling: Billing = {
    billingNumber: "",
    amount: "",
    fromDate: "",
    toDate: "",
    projectId: "",
    projectName: "",
    notes: "",
    pdfId: "",
    approval: "[]",
    approverNotes: "",
    submitterEmail: "",
    submitTime: "",
    updaterEmail: "",
    updateTime: "",
    requestorEmail: "",
    notify: "",
    billed: "",
    billable: "",
    void: "",
    voidReason: "",
};

export function parseApproval(approval: string): BillingApprovalLevel[] {
    if (!approval) return [];
    try {
        const parsed = JSON.parse(approval);
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
}

export function getBillingDecision(approval: string) {
    const levels = parseApproval(approval);
    if (levels.find(level => level.approverDecision === "Rejected")) return "Rejected";
    if (levels.length && levels.every(level => level.approverDecision === "Approved")) return "Approved";
    return "Submitted";
}
